import { createSlice } from "@reduxjs/toolkit";
import { PostAnalysisProps } from "./PostAnalysis";

const initialState: PostAnalysisProps.state = {
  postAnalysisModalOpen: false,
  active_post_id: "",
  post_analysis_list: {},
};

const slice = createSlice({
  initialState,
  name: "postAnalysis",
  reducers: {
    setPostAnalysisModalOpen: (
      state,
      action: PostAnalysisProps.setPostAnalysisModalOpen
    ) => {
      state.postAnalysisModalOpen = action.payload;
    },
    setActivePostId: (state, action: PostAnalysisProps.setActivePostId) => {
      state.active_post_id = action.payload;
    },
    setPostAnalysisList: (
      state,
      action: PostAnalysisProps.setPostAnalysisList
    ) => {
      state.post_analysis_list[action.payload.post_id] = action.payload;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const postAnalysisActions = slice.actions;
export const postAnalysisReducer = slice.reducer;
